import { z } from 'zod';

export const courseFormSchema = z.object({
  name: z.string().min(1, 'Name is required').max(256, 'Name must be less than 256 characters'),
  description: z.string().max(1000, 'Description must be less than 1000 characters').optional().or(z.literal('')),
  spanishName: z.string().max(256, 'Spanish name must be less than 256 characters').optional().or(z.literal('')),
  spanishDescription: z
    .string()
    .max(1000, 'Spanish description must be less than 1000 characters')
    .optional()
    .or(z.literal('')),
  categoryIds: z.array(z.string()).optional().default([]),
  isRecommended: z.boolean().optional().default(false),
  guides: z
    .array(
      z.object({
        guideId: z.string(),
        title: z.string(),
        isPublished: z.boolean(),
        position: z.number(),
      }),
    )
    .optional()
    .default([]),
});

export type CourseFormData = z.infer<typeof courseFormSchema>;
